// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29DO8","col":"styles_col__zELtW"};